var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.835 18.339H16.17V14.162C16.17 13.166 16.15 11.884 14.78 11.884C13.391 11.884 13.179 12.968 13.179 14.089V18.339H10.513V9.75H13.073V10.92H13.108C13.466 10.246 14.336 9.533 15.636 9.533C18.336 9.533 18.836 11.311 18.836 13.624V18.339H18.835ZM7.503 8.575C7.29956 8.57526 7.09806 8.53537 6.91006 8.45761C6.72207 8.37984 6.55127 8.26574 6.40746 8.12184C6.26365 7.97793 6.14965 7.80706 6.07201 7.61901C5.99437 7.43097 5.9546 7.22944 5.955 7.026C5.9552 6.71983 6.04618 6.4206 6.21644 6.16615C6.3867 5.91169 6.62859 5.71343 6.91153 5.59645C7.19447 5.47947 7.50574 5.44902 7.80598 5.50894C8.10622 5.56886 8.38196 5.71648 8.59831 5.93311C8.81466 6.14974 8.96191 6.42566 9.02145 6.72598C9.08099 7.0263 9.05013 7.33753 8.93278 7.62032C8.81543 7.9031 8.61687 8.14474 8.36219 8.31467C8.10751 8.4846 7.80817 8.5752 7.502 8.575H7.503ZM8.839 18.339H6.166V9.75H8.84V18.339H8.839ZM20.17 3H4.829C4.093 3 3.5 3.58 3.5 4.297V19.703C3.5 20.42 4.094 21 4.828 21H20.166C20.9 21 21.5 20.42 21.5 19.703V4.297C21.5 3.58 20.9 3 20.166 3H20.169H20.17Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.5f17f35ac395df99b513564987c9217d.svg";
export { ForwardRef as ReactComponent };